import { reportError, reportErrorNow } from '@ms/yammer-telemetry';
import type { AuthenticatorOptions } from '@ms/yammer-web-authenticators';
import {
  AcquireTokenAuthError,
  AcquiredTokenExpiredError,
  HandleTokenInUrlError,
  TokenExpirationParsingError,
  UnsupportedScopeError,
} from '@ms/yammer-web-authenticators';

export const reportAuthError: AuthenticatorOptions['onError'] = async (error, { authenticatorType, scopes }) => {
  const eventProperties = {
    authenticatorType,
    ...(scopes ? { scopes: scopes.join(',') } : null),
  };

  if (error instanceof AcquiredTokenExpiredError) {
    reportError({
      error,
      eventProperties: {
        ...eventProperties,
        expiration: error.expiration,
        endTime: error.endTimestamp,
        errorCode: 'AuthAcquiredTokenExpired',
        startTime: error.startTimestamp,
      },
      skipAuthentication: true,
    });
  }

  if (error instanceof AcquireTokenAuthError) {
    await reportErrorNow({
      error,
      eventProperties: {
        ...eventProperties,
        errorCode: 'AuthAcquireTokenSilentFailed',
      },
      skipAuthentication: true,
    });
  }

  if (error instanceof HandleTokenInUrlError) {
    reportError({
      error,
      eventProperties: {
        ...eventProperties,
        errorCode: 'AuthHandleTokenInUrlFailed',
      },
      skipAuthentication: true,
    });
  }

  if (error instanceof TokenExpirationParsingError) {
    reportError({
      error,
      eventProperties: {
        ...eventProperties,
        errorCode: 'AuthTokenExpirationParsingFailed',
      },
      skipAuthentication: true,
    });
  }

  if (error instanceof UnsupportedScopeError) {
    reportError({
      error,
      eventProperties: {
        ...eventProperties,
        errorCode: 'AuthUnsupportedScopeProvided',
      },
      skipAuthentication: true,
    });
  }
};
